import { Alert, List, ListItemText } from '@mui/material'
import { AxiosError } from 'axios'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  serverErrors: Error
}

interface ServerErrors {
  message: string
  type: string
  fieldErrors: object
}

const ServerErrorsAlert = ({ serverErrors }: Props): JSX.Element => {
  const { t } = useTranslation()
  const response = (serverErrors as AxiosError)?.response
  const errors = response?.data as ServerErrors

  return (
    <Alert sx={{ mb: 2 }} severity="error">
      {errors?.type === 'FieldValidations' && (
        <List disablePadding>
          {Object.values(errors?.fieldErrors).map((error: Record<string, string>) => {
            return (
              <ListItemText key={Object.keys(error)[0]} sx={{ m: 0, p: 0 }}>
                {t(`common.errors.${error[Object.keys(error)[0]]}`, { defaultValue: error[Object.keys(error)[0]] })}
              </ListItemText>
            )
          })}
        </List>
      )}
      {(response?.status === 400 || response?.status === 404) && !errors?.type && (
        <div>{t(`common.errors.${response.data as string}`, response.data as string)}</div>
      )}
      {errors?.type === 'BusinessValidationError' && <div>{t(`common.errors.${errors.message}`, errors.message)}</div>}
      {response?.status === 409 && !errors?.type && <div>{t('conflict.modificationConflict')}</div>}
      {!errors && <div>{serverErrors.message}</div>}
    </Alert>
  )
}

export default ServerErrorsAlert
